// extracted by mini-css-extract-plugin
module.exports = {"labelContent":"_970223e","infoPrompt":"_97b7cb7"};